module.exports = __webpack_public_path__ + "static/media/flute.c0862e25.wav";